import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from "js-cookie";

export const profileAPI = createApi({
  reducerPath: "profileAPI",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),
  prepareHeaders: (headers) => {
    const token = Cookies.get("authToken");
    if (token) {
      headers.set("Authorization", `${token}`);
    }
    return headers;
  },
  endpoints: (builder) => ({
    apiprofile: builder.mutation({
      query: (payload) => ({
        url: `/api/carrer/profile`,
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const { useApiprofileMutation } = profileAPI;
